import React, { useState, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';

export default function Buscador({
    placeholder = 'Seleccione...', 
    datos = [], 
    colId, 
    colNombre, 
    register,
    registerOptions,
    setValue, getValues,
    callbackSuccess,
    callbackBlank,
    minLength = 3}) {

    /* https://react-bootstrap.netlify.app/docs/components/dropdowns#customization */  

    const initValue = getValues(colId) || '';
    
    const [label, setLabel] = useState('');
    
    useEffect(() => {
      async function initLabelValue() {
        datos.map(d => {
          if (d[colId] === initValue) {
            setLabel(d[colNombre]);
          }
        });
      } 
      initLabelValue(); 
    }, [initValue])
    
    const [autoFocus, setAutoFocus] = useState(false);

    const CustomToggle2 = React.forwardRef(({ children, onClick }, ref) => (
        <>
          <Form.Control
                autoFocus={autoFocus}
                placeholder={placeholder}
                value={label}
                onChange={(e) => {
                  let val = e.target.value 
                  setLabel(val);
                  if (val=='') {
                    callbackBlank();
                    setValue(colId, '');
                  }
                }}
                onClick={(e) => {
                    e.preventDefault();
                    setAutoFocus(true);
                    onClick(e);
                  }}
              >
          </Form.Control>
        </>
              
    ));

    const CustomMenu = React.forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
          
          return (
            <div
              ref={ref}
              style={style}
              className={className}
              aria-labelledby={labeledBy}
            >
              <ul className="list-unstyled">
                {React.Children.toArray(children).filter(
                  (child) =>
                    !label || child.props.children.toLowerCase().includes(label.toLowerCase()),
                )}
              </ul>
            </div>
          );
        },
    );

    return (
        <Dropdown>
            <input value={getValues(colId) || ''} type="hidden"
                            {...register(colId, registerOptions)} />
            <Dropdown.Toggle as={CustomToggle2} id="dropdown-custom-components">
                {placeholder}
            </Dropdown.Toggle>
            {(label!=='' && label.length>=minLength)?
              <Dropdown.Menu as={CustomMenu} >
                  {datos.map((d, index) => 
                    <Dropdown.Item key={index} data-id={d[colId]}
                        onClick={(e) => {
                            //console.log(e.target.getAttribute('data-id'));
                            setValue(colId, e.target.getAttribute('data-id'));
                            setLabel(e.target.text);
                            callbackSuccess();
                            setAutoFocus(false);
                          }}>
                      {d[colNombre]}
                    </Dropdown.Item>)}
              </Dropdown.Menu>
            :<></>}
        </Dropdown>
    );

}